"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldRenderSearchAltProviderButton = exports.getBackToSearchPageUrl = void 0;
var _urlSearchParams = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url-search-params"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _constants = require("./constants");
const getBackToSearchPageUrl = clinicalKeyword => {
  const origin = window.location.origin;
  const searchParams = new _urlSearchParams.default(window.location.search);
  (0, _forEach.default)(_constants.SEARCH_TYPE_HEAD_SUGGESTED_CATEGORIES).call(_constants.SEARCH_TYPE_HEAD_SUGGESTED_CATEGORIES, category => {
    if (searchParams.has(category)) {
      searchParams.delete(category);
    }
  });
  searchParams.set('clinical_keywords', clinicalKeyword);
  return `${origin}/search?${searchParams.toString()}`;
};
exports.getBackToSearchPageUrl = getBackToSearchPageUrl;
const shouldRenderSearchAltProviderButton = _ref => {
  let {
    currentState,
    searchMatchEnabled,
    stepWithClinicalKeyword
  } = _ref;
  return searchMatchEnabled && (currentState.matches(_constants.states.error) || currentState.matches(_constants.states.warning)) && !!stepWithClinicalKeyword?.answer;
};
exports.shouldRenderSearchAltProviderButton = shouldRenderSearchAltProviderButton;